<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      plaid: null
    }
  },
  mounted() {
    if (!window.Plaid) {
      const that = this
      const plaidScript = document.createElement("script")
      plaidScript.src =
        "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
      plaidScript.onload = function () {
        that.plaid = window.Plaid
      }
      document.getElementsByTagName("head")[0].appendChild(plaidScript)
    } else {
      this.plaid = window.Plaid
    }
  }
}
</script>
